"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _Checkbox = _interopRequireDefault(require("./Checkbox"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "checkbox": "DefaultTheme__checkbox___1QMds",
  "assistive-text": "DefaultTheme__assistive-text___3Fqqf",
  "box-shape": "DefaultTheme__box-shape___1_CBP",
  "bar": "DefaultTheme__bar___1ts46",
  "checked": "DefaultTheme__checked___Cbw9V",
  "indeterminate": "DefaultTheme__indeterminate___2gC0x",
  "disabled": "DefaultTheme__disabled___14VkI",
  "is-focused": "DefaultTheme__is-focused___3KyYI",
  "assistiveText": "DefaultTheme__assistive-text___3Fqqf",
  "boxShape": "DefaultTheme__box-shape___1_CBP",
  "isFocused": "DefaultTheme__is-focused___3KyYI"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "checkbox": "DarkTheme__checkbox___wS4HH",
  "checked": "DarkTheme__checked___3R7Ro",
  "indeterminate": "DarkTheme__indeterminate___Us8gu",
  "is-focused": "DarkTheme__is-focused___PriUD",
  "isFocused": "DarkTheme__is-focused___PriUD"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "checkbox": "LumeTheme__checkbox___2aVzg"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)(_Checkbox["default"].displayName, themes.DefaultTheme)(_Checkbox["default"]);
ThemedComponent.displayName = _Checkbox["default"].displayName;
ThemedComponent.themes = themes;
ThemedComponent.isFormComponent = true;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map